import { AfterViewInit, Component, EventEmitter, Input, Output } from "@angular/core";
import { PayAccountService } from "@main-services/pay_account.service";
import { FiatService } from "@main-services/currency/fiat.service";
import { AccountService } from "@modules/account/services/account.service";
import { UserService } from "@main-services/user.service";
import { PaymentAccount } from "@models/payment_account";
import { Provider } from "@models/interfaces";
import { PaymentOption, PayoutAccount, PayoutProvider } from "@models";
import { PayoutTileComponent } from "./payout-tile.component";
import { MasterdataService } from "@core-services/masterdata.service";
import { TranslationService } from "@core-services/translation.service";

@Component({
	selector: "payment-tile",
	templateUrl: "./payout-tile.component.html",
	styleUrls: ["./payout-tile.component.scss"],
	standalone: false
})
export class PaymentTileComponent extends PayoutTileComponent implements AfterViewInit {
	@Input()
	public account: PaymentAccount = null;

	@Output()
	public deleteAccount = new EventEmitter<PaymentAccount>();

	public constructor(
		protected masterdataService: MasterdataService,
		protected translationService: TranslationService,
		protected payoutservice: PayAccountService,
		protected fiatService: FiatService,
		protected userService: UserService,
		protected accountService: AccountService
	) {
		super(masterdataService, translationService, payoutservice, fiatService, userService, accountService);
	}

	public get paymentOptionForSepa(): PaymentOption {
		return this.masterdataService.payment_options.find((p: PaymentOption) =>
			this.masterdataService.isSepaProvider(p)
		);
	}

	public get providerForced(): Provider {
		if (this.provider != null) {
			return this.provider;
		}
		return this.masterdataService.payout_providers.find((p: PayoutProvider) =>
			this.masterdataService.isSepaProvider(p)
		);
	}

	public getPrimaryFieldValue(): string {
		if (this.account) {
			return this.account.bankAccountDetails.getIban();
		}
		return "";
	}

	public logoUrl(p: PayoutAccount | Provider): string {
		return this.masterdataService.logoUrl(this.paymentOptionForSepa);
	}

	public getBankName(): string {
		return this.account.bankAccountDetails.getBankName();
	}

	public getHolderName(): string {
		return this.account.bankAccountDetails.getHolder();
	}
}
